export type GestorJornadaSituacao = 'ATRASADA' | 'PROXIMA' | 'OK' | 'SEM_HISTORICO'

export type GestorJornadaMembro = {
  id: string
  nomeCompleto: string
  setor: string | null
  cadenciaDias: number
  ultimaOneOnOneEm: string | null
  proximaOneOnOneEm: string
  situacao: GestorJornadaSituacao
  feedbackResumo: {
    anotacoesPrivadas: number
    feedbackRascunho: number
    feedbackLiberado: number
  }
}

export type GestorJornadaDashboard = {
  resumo: {
    totalMembros: number
    atrasadas: number
    proximas7d: number
    feedbackRascunhos: number
  }
  proximosOneOnOne: GestorJornadaMembro[]
  feedbackPendente: Array<{ id: string; nomeCompleto: string; rascunhos: number }>
  membros: GestorJornadaMembro[]
}

export type GestorOneOnOneRegistro = {
  id: string
  realizadaEm: string
  notas: string | null
  author: { id: string; name: string }
  createdAt: string
}

export const JORNADA_CADENCIAS = [30, 60, 90] as const
export type JornadaCadenciaDias = (typeof JORNADA_CADENCIAS)[number]

export const JORNADA_SITUACAO_LABEL: Record<GestorJornadaSituacao, string> = {
  ATRASADA: 'Atrasada',
  PROXIMA: 'Próxima',
  OK: 'Em dia',
  SEM_HISTORICO: 'Sem histórico',
}

export const JORNADA_SITUACAO_CLASS: Record<GestorJornadaSituacao, string> = {
  ATRASADA: 'bg-red-500/15 text-red-400 ring-red-500/30',
  PROXIMA: 'bg-amber-500/15 text-amber-400 ring-amber-500/30',
  OK: 'bg-emerald-500/15 text-emerald-400 ring-emerald-500/30',
  SEM_HISTORICO: 'bg-white/[0.06] text-text-muted ring-white/10',
}

export function formatJornadaDate(iso: string) {
  return new Date(iso).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

export function daysUntil(iso: string) {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const target = new Date(iso)
  target.setHours(0, 0, 0, 0)
  return Math.round((target.getTime() - today.getTime()) / 86_400_000)
}
